<div
  class="datetime-wrapper"
  [ngClass]="{'disabled': disabled, 'has-error': isIncorrectValue}"
>

  <ion-item class="datetime-item" [lines]="lines">

    <div
      class="result-datetime"
      [ngClass]="{'placeholder': !formattedDate}"
      (click)="openModal()"
    >
      {{ (formattedDate || placeholder) | titlecase }}
    </div>

    @if (canDelete && internalValue && !disabled) {

      <div
        class="remove-button"
        slot="end"
        (click)="removeDate()"
      >
        <yu-icon name="x-circle"></yu-icon>
      </div>

    }

  </ion-item>

  <div class="label-text">{{ label }}</div>

</div>

@if (isIncorrectValue) {
  <yu-helper color="error" icon="warning-circle">{{ helperText }}</yu-helper>
}
